import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CourseService } from 'src/app/services/course.service';

@Component({
  selector: 'app-add-lesson',
  templateUrl: './add-lesson.component.html',
  styleUrls: ['./add-lesson.component.scss']
})
export class AddLessonComponent implements OnInit {

  constructor(public courseService: CourseService, private toastrService:ToastrService, private router: Router) { }

  public lessonForm:FormGroup;
  public fileName:any = 'No file chosen';
  public isUpdate:boolean = false;
  public moduleId:any;
  public courseId:any;
  public lessonId:any;
  public responseBody:any = {};
  public isLoading:boolean = false;

  ngOnInit(): void {
    this.lessonForm = new FormGroup({
      title: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      video: new FormControl('', [Validators.required]),
      isPreview: new FormControl(false, [Validators.required]),
      serialNo: new FormControl('', [Validators.required]),
      duration: new FormControl('', Validators.required)
    });
    let url = this.router.url.split('/');
    this.courseId = url[2];
    this.moduleId = url[4];
    if(url.includes('modify')){
      this.isUpdate = true;
      this.lessonId = url[6];
      this.courseService.getLesson(url[2], url[4], url[6]).subscribe(
        (res:any)=>{
          this.responseBody['title']=res['title'];
          this.responseBody['description']=res['description'];
          this.responseBody['video']=res['video'];
          this.responseBody['isPreview']=res['isPreview'];
          this.responseBody['serialNo'] = res['serialNo'];
          this.responseBody['duration'] = res['duration'];
          this.lessonForm.patchValue(this.responseBody);
          this.fileName = res.video.filename;
        }
      )
    }
  }

  onFileUpload(event){
    if(event.target.files && event.target.files[0]){
      this.fileName = event.target.files[0].name;
      this.lessonForm.get('video').setValue(event.target.files[0]);
    }
  }

  onCreateLesson(){
    this.isLoading = true;
    let data = this.onCreateFormData();
    if(data){
      this.courseService.addLesson(data, this.courseId, this.moduleId).subscribe(
        res=>{
          this.isLoading = false;
          this.toastrService.success('Lesson added!');
          history.back();
        }
      );
    }

  }

  onClickCancel(){
    history.back();
  }

  onUpdateLesson(){
    this.isLoading = true;
    let data = this.onCreateFormData();
    if(data){
      this.courseService.updateLesson(data, this.courseId, this.moduleId, this.lessonId).subscribe(
        res=>{
          this.isLoading = false;
          this.toastrService.success('Lesson updated!');
          history.back();
        }
      )
    }

  }

  onCreateFormData(){
    if(this.lessonForm.valid){
      let {title, description, video, isPreview, serialNo, duration} = this.lessonForm.value;
      let formData = new FormData();
      formData.append('title', title);
      formData.append('description', description);
      formData.append('video', video);
      formData.append('isPreview', isPreview);
      formData.append('serialNo', serialNo);
      formData.append('duration', duration);
      return formData;
    }
    else {
      this.isLoading = false;
      this.toastrService.error("Please fill all the fields!");
      return '';
    }
  }

}
